import { Injectable, Inject, Optional, PLATFORM_ID, StateKey, makeStateKey, TransferState } from '@angular/core';
import { isPlatformServer, isPlatformBrowser } from '@angular/common';
import { DISABLE_ANDROID_DOWNLOAD, DISABLE_IOS_DOWNLOAD } from 'src/app/tokens/ssr-flags.token';

const DISABLE_IOS_BANNER_KEY: StateKey<boolean> = makeStateKey<boolean>('disableiOSDownload');
const DISABLE_ANDROID_BANNER_KEY: StateKey<boolean> = makeStateKey<boolean>('disableAndroidDownload');

@Injectable({ providedIn: 'root' })
export class AppServiceFeatureFlagsService {
  disableIOSBanner = false;
  disableAndroidBanner = false;

  constructor(
    private transferState: TransferState,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Optional() @Inject(DISABLE_IOS_DOWNLOAD) private disableIOSDownload: boolean,
    @Optional() @Inject(DISABLE_ANDROID_DOWNLOAD) private disableAndroidDownload: boolean
  ) {
    if (isPlatformServer(this.platformId)) {
      // On express server, write server-provided values to TransferState
      this.transferState.set(DISABLE_IOS_BANNER_KEY, this.disableIOSDownload ?? false);
      this.transferState.set(DISABLE_ANDROID_BANNER_KEY, this.disableAndroidDownload ?? false);

      // store in service properties so server-side components can use them
      this.disableIOSBanner = this.disableIOSDownload ?? false;
      this.disableAndroidBanner = this.disableAndroidDownload ?? false;
    } else {
      // Browser: read from TransferState
      this.disableIOSBanner = this.transferState.get(DISABLE_IOS_BANNER_KEY, false);
      this.disableAndroidBanner = this.transferState.get(DISABLE_ANDROID_BANNER_KEY, false);
    }
  }

  isIOSBannerDisabled(): boolean {
    return this.disableIOSBanner;
  }

  isAndroidBannerDisabled(): boolean {
    return this.disableAndroidBanner;
  }
}
